'use client';

import React, { useMemo } from 'react';
import { CompareBlock } from '@kohler-dsm-library/kohler-modules';

export default function CompareBlockWrapper(props) {
  // Memoize the DSM props to prevent object recreation on each render
  const dsmProps = useMemo(() => {
    return {
      ...props,
      ...(props.CTA && {
        CTA: {
          ...props.CTA,
          onClick: async () => {
            console.log('Button Click!!!');
          },
        },
      }),
    };
  }, [props]);

  return <CompareBlock {...dsmProps} />;
}
